import { render, staticRenderFns } from "./ImportedActivityPlaceholder.vue?vue&type=template&id=57548385&scoped=true&"
import script from "./ImportedActivityPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./ImportedActivityPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./ImportedActivityPlaceholder.vue?vue&type=style&index=0&id=57548385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57548385",
  null
  
)

export default component.exports